import { z } from 'zod';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import {
  usersSortByValues,
  userStatus,
} from 'src/pages/settings/organisation/users/mappings';

export function usePageParams() {
  return usePageParamsFromSchema(getUsersPageParamsSchema(), {
    filters: {
      status: { label: 'Status' },
      permissionGroupId: { label: 'Permission Groups' },
      name: { label: 'Name' },
      email: { label: 'Email' },
    },
  });
}

export type PageParams = ReturnType<typeof usePageParams>;

function getUsersPageParamsSchema() {
  return z.object({
    sortBy: z.enum(usersSortByValues).default('EMAIL'),
    sortDirection: ascSortDirectionSchema,
    status: z.preprocess(
      preprocessAsArray,
      z.array(z.enum(userStatus)).default([])
    ),
    permissionGroupId: z
      .preprocess(preprocessAsArray, z.array(z.string()).default([]))
      .nullable(),
    name: z.string().nullable().default(null),
    email: z.string().nullable().default(null),
    ...getPaginationSchema({ pageSize: 20 }).shape,
  });
}
